import { render } from "./xtx-pagination.vue?vue&type=template&id=5483b125&scoped=true"
import script from "./xtx-pagination.vue?vue&type=script&lang=js"
export * from "./xtx-pagination.vue?vue&type=script&lang=js"

import "./xtx-pagination.vue?vue&type=style&index=0&id=5483b125&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\three_2\\ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5483b125"]])

export default __exports__